import { render, staticRenderFns } from "./IgConnectionFaq.vue?vue&type=template&id=4c1cfc50&scoped=true&"
import script from "./IgConnectionFaq.vue?vue&type=script&lang=js&"
export * from "./IgConnectionFaq.vue?vue&type=script&lang=js&"
import style0 from "./IgConnectionFaq.vue?vue&type=style&index=0&id=4c1cfc50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cfc50",
  null
  
)

export default component.exports